import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Chip from '@mui/material/Chip';

const Show = ({ open, onClose, itemData }) => {
  if (!itemData) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ 
        m: 0, 
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Typography variant="h6">
          Détails de l'événement
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Nom
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.name}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Description
          </Typography>
          <Typography variant="body1" gutterBottom>
            {itemData.description}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Villes
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {itemData.villes && itemData.villes.map((ville) => (
              <Chip
                key={ville}
                label={ville}
                size="small"
                sx={{
                  backgroundColor: '#f5f5f5',
                  borderRadius: '16px'
                }}
              />
            ))}
          </Box>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Période d'achat
          </Typography>
          <Typography variant="body1" gutterBottom>
            Du {formatDate(itemData.debut_achats)} au {formatDate(itemData.fin_achats)}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Période de l'événement
          </Typography>
          <Typography variant="body1" gutterBottom>
            Du {formatDate(itemData.debut_evenement)} au {formatDate(itemData.fin_evenement)}
          </Typography>
        </Box>

        <Box sx={{ py: 1 }}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Statut
          </Typography>
          <Typography 
            variant="body1" 
            gutterBottom 
            sx={{ 
              textTransform: 'capitalize',
              display: 'inline-block',
              px: 2,
              py: 0.5,
              borderRadius: 1,
              backgroundColor: 
                itemData.statut === 'en cours' ? '#e3f2fd' :
                itemData.statut === 'a venir' ? '#e8f5e9' :
                itemData.statut === 'terminé' ? '#ffebee' : 
                'transparent',
              color:
                itemData.statut === 'en cours' ? '#1976d2' :
                itemData.statut === 'a venir' ? '#2e7d32' :
                itemData.statut === 'terminé' ? '#d32f2f' :
                'inherit',
            }}
          >
            {itemData.statut}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button 
          onClick={onClose}
          variant="contained"
          sx={{ 
            backgroundColor: 'primary.main',
            borderRadius: '8px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#333'
            }
          }}
        >
          Fermer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

Show.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  itemData: PropTypes.shape({
    id: PropTypes.number,
    nom: PropTypes.string,
    description: PropTypes.string,
    debut_achats: PropTypes.string,
    fin_achats: PropTypes.string,
    debut_evenement: PropTypes.string,
    fin_evenement: PropTypes.string,
    statut: PropTypes.string,
    villes: PropTypes.arrayOf(PropTypes.string)
  }),
};

export default Show;